import axios from 'axios';
import Buefy from 'buefy';
import 'buefy/dist/buefy.css';
import VueLazyload from 'vue-lazyload';

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';

Vue.use(Buefy);
Vue.use(VueLazyload);

Vue.config.productionTip = false;

if (process.env.NODE_ENV === 'development') {
  axios.defaults.baseURL = 'http://localhost:3000/';
} else {
  axios.defaults.baseURL = 'https://api.saltcreekcwrt.org/';
}

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
